import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedger/BcRevenueTransactionsResponseDto";
import { NetChargesRequestDto } from "../../../../core/models/bcLedger/netChargesRequestDto";
import { BcRevenueTransactionsComponent } from "../bc-revenue-transactions/bc-revenue-transactions.component";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { BcledgerService } from "../../../../core/services/bcledger.service";

@Component({
  selector: "jni-nets-charged",
  templateUrl: "./nets-charged.component.html",
  styleUrls: ["./nets-charged.component.scss"],
  imports: [BcRevenueTransactionsComponent],
})
export class NetsChargedComponent implements OnInit, OnChanges {
  netChargedParams!: NetChargesRequestDto;
  @Input() bcLedgerStacker!: BcLedgerStacker;
  netChargedList: BcRevenueTransactionsData[] = [];
  TotalBCRevenue!: number;
  TotalBCGP!: number;
  BCAvgMargin!: number;
  TotalBCCommission!: number;
  TotalBCReserve!: number;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _netChargedService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.netChargedParams = { ...params } as NetChargesRequestDto;
      this.netChargedParams.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getNetCharges(this.netChargedParams);
  }

  getNetCharges(payload: NetChargesRequestDto) {
    this._loaderService.setLoaderState(true);
    this._netChargedService.netCharges(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.netChargedList = res.data.Data ?? [];
          this.TotalBCRevenue = res.data.TotalBCRevenue;
          this.TotalBCGP = res.data.TotalBCGP;
          this.BCAvgMargin = res.data.BCAvgMargin;
          this.TotalBCCommission = res.data.TotalBCCommission;
          this.TotalBCReserve = res.data.TotalBCReserve;
          return;
        }
        this._toastrService.error(res.message ?? "No results found", "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("Net Charges Not Fetched", "Net Charges");
      },
    });
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.netChargedParams = { ...this.bcLedgerStacker };
      this.netChargedParams.CategoryID = "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
